// extracted by mini-css-extract-plugin
export default {"fragment":"ChallengeIntroNotify_fragment__8V0wl"};